import { prepareEmptyMarket } from "../prepareEmptyMarket";
import { pickLiveOrPreliveId } from "../pickLiveOrPreliveId";
import { findFirstAvailableMarket } from "../findFirstAvailableMarket";
export const getAvailableFixtureMarket = (eventId, isLive, markets, sport) => {
    const marketsInConfig = sport.config.markets;
    const ids = marketsInConfig.map(m => pickLiveOrPreliveId(m, isLive));
    const market = findFirstAvailableMarket(markets, ids);
    return market || prepareEmptyMarket(eventId, marketsInConfig[0].template, 0);
};
//# sourceMappingURL=getAvailableFixtureMarket.js.map